import { useState } from 'react';
import { TabletDevice } from '../../components/TabletDevice.js';
import type { Action, OnboardingState } from './state.js';

const MAX = 200;

interface Props {
  state: OnboardingState;
  dispatch: React.Dispatch<Action>;
  onNext: () => void;
  onBack: () => void;
}

export function Step5Message({ state, dispatch, onNext }: Props) {
  const [mode, setMode] = useState<'mot' | 'photo'>(state.messageMode);
  const [contenu, setContenu] = useState(state.messageContenu);

  function handleNext() {
    dispatch({ type: 'SET_MESSAGE', mode, contenu });
    onNext();
  }

  const now = new Date();
  const h = String(now.getHours()).padStart(2, '0');
  const m = String(now.getMinutes()).padStart(2, '0');

  return (
    <div
      className="container"
      style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'start' }}
    >
      <div style={{ position: 'sticky', top: '160px' }}>
        <div className="eyebrow" style={{ marginBottom: '12px' }}>
          Étape 4 — Premier mot
        </div>
        <h1
          className="display"
          style={{ fontSize: 'clamp(42px, 4.5vw, 64px)', margin: '0 0 20px' }}
        >
          Un mot pour <em>{state.seniorPrenom || 'votre proche'}</em>.
        </h1>
        <p
          className="serif"
          style={{
            fontStyle: 'italic',
            fontWeight: 300,
            fontSize: '18px',
            lineHeight: 1.4,
            color: 'var(--ink-soft)',
            marginBottom: '24px',
          }}
        >
          Il apparaîtra sur l'écran dès la livraison.
        </p>
        {/* Aperçu live tablette */}
        <div style={{ marginTop: '8px' }}>
          <TabletDevice
            time={`${h}:${m}`}
            day="aujourd'hui"
            date="premier jour"
            hi={contenu ? `« ${contenu.slice(0, 30)}… »` : 'en attente…'}
          />
        </div>
      </div>

      <div className="card">
        {/* Toggle mode */}
        <div
          style={{
            display: 'flex',
            background: 'var(--paper-2)',
            borderRadius: '999px',
            padding: '4px',
            marginBottom: '24px',
          }}
        >
          {(['mot', 'photo'] as const).map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => setMode(m)}
              style={{
                flex: 1,
                padding: '9px',
                borderRadius: '999px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                background: mode === m ? 'var(--paper)' : 'transparent',
                color: mode === m ? 'var(--ink)' : 'var(--ink-muted)',
                boxShadow: mode === m ? 'var(--shadow-card)' : 'none',
                transition: 'all .15s ease',
              }}
            >
              {m === 'mot' ? '✍ Un mot' : '📷 Une photo'}
            </button>
          ))}
        </div>

        {mode === 'mot' ? (
          <div className="field">
            <label htmlFor="message-contenu">Votre message</label>
            <textarea
              id="message-contenu"
              rows={5}
              value={contenu}
              onChange={(e) => setContenu(e.target.value.slice(0, MAX))}
              placeholder={`Bonjour ${state.seniorPrenom || 'Mamie'} ! On pense très fort à toi. ❤`}
              style={{ resize: 'vertical' }}
            />
            <div className="hint" style={{ textAlign: 'right' }}>
              {contenu.length} / {MAX}
            </div>
          </div>
        ) : (
          <div
            className="placeholder-img"
            style={{
              height: '160px',
              borderRadius: '10px',
              marginBottom: '18px',
              cursor: 'not-allowed',
            }}
          >
            <div className="ph-caption">Photo non disponible en démo</div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px' }}>
          <button type="button" className="btn btn-secondary" onClick={onNext} style={{ flex: 1 }}>
            Passer
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleNext}
            style={{ flex: 1 }}
          >
            Envoyer & continuer
          </button>
        </div>
      </div>
    </div>
  );
}
